/* Rendus vectoriels des raquettes et accessoires MURO.
   Chaque face porte Marcel, le wordmark et la plaque de rue de son quartier. */

const MURO_WORD = 'M7.2 0.0V-58.6V-105.60000000000001H34.6V-62.6H36.2Q37.6 -79.4 41.7 -89.4Q45.800000000000004 -99.4 52.7 -103.9Q59.6 -108.4 69.2 -108.4Q79.2 -108.4 85.4 -103.5Q91.60000000000001 -98.60000000000001 94.60000000000001 -88.5Q97.60000000000001 -78.4 97.4 -62.6H99.0Q100.4 -79.2 104.80000000000001 -89.2Q109.2 -99.2 116.4 -103.80000000000001Q123.60000000000001 -108.4 133.4 -108.4Q141.6 -108.4 147.60000000000002 -105.4Q153.60000000000002 -102.4 157.70000000000002 -96.4Q161.8 -90.4 163.8 -81.30000000000001Q165.8 -72.2 165.8 -60.0V0.0H133.4V-57.2Q133.4 -64.8 132.10000000000002 -69.9Q130.8 -75.0 128.20000000000002 -77.5Q125.60000000000001 -80.0 121.60000000000001 -80.0Q116.4 -80.0 112.0 -75.30000000000001Q107.60000000000001 -70.60000000000001 104.9 -61.2Q102.2 -51.800000000000004 102.2 -37.4V0.0H70.60000000000001V-58.0Q70.60000000000001 -65.60000000000001 69.30000000000001 -70.4Q68.0 -75.2 65.3 -77.6Q62.6 -80.0 58.6 -80.0Q53.6 -80.0 49.3 -75.9Q45.0 -71.8 42.3 -62.4Q39.6 -53.0 39.6 -37.4V0.0ZM208.0 2.8000000000000003Q190.8 2.8000000000000003 182.5 -9.200000000000001Q174.2 -21.200000000000003 174.2 -46.0V-105.60000000000001H206.6V-46.400000000000006Q206.6 -34.800000000000004 209.89999999999998 -30.200000000000003Q213.2 -25.6 219.4 -25.6Q223.8 -25.6 227.5 -27.900000000000002Q231.2 -30.200000000000003 234.0 -34.900000000000006Q236.8 -39.6 238.3 -47.0Q239.8 -54.400000000000006 239.8 -64.8V-105.60000000000001H272.2V-47.6V0.0H244.60000000000002V-41.2H243.2Q242.0 -25.8 237.8 -16.1Q233.60000000000002 -6.4 226.20000000000002 -1.8Q218.8 2.8000000000000003 208.0 2.8000000000000003ZM282.59999999999997 0.0V-57.400000000000006V-105.60000000000001H310.59999999999997V-63.6H312.2Q313.4 -80.4 316.9 -90.10000000000001Q320.4 -99.80000000000001 325.7 -103.9Q331.0 -108.0 337.59999999999997 -108.0Q341.2 -108.0 345.1 -107.0Q349.0 -106.0 352.79999999999995 -103.80000000000001L351.2 -67.8Q346.79999999999995 -70.4 342.59999999999997 -71.7Q338.4 -73.0 334.59999999999997 -73.0Q328.2 -73.0 323.79999999999995 -69.4Q319.4 -65.8 317.09999999999997 -58.8Q314.79999999999995 -51.800000000000004 314.79999999999995 -41.800000000000004V0.0ZM407.79999999999995 2.8000000000000003Q392.59999999999997 2.8000000000000003 380.79999999999995 -3.3Q369.0 -9.4 362.4 -21.7Q355.79999999999995 -34.0 355.79999999999995 -52.6Q355.79999999999995 -72.0 362.69999999999993 -84.30000000000001Q369.59999999999997 -96.60000000000001 381.5 -102.5Q393.4 -108.4 408.4 -108.4Q424.0 -108.4 435.7 -102.30000000000001Q447.4 -96.2 453.9 -83.9Q460.4 -71.60000000000001 460.4 -52.800000000000004Q460.4 -33.4 453.5 -21.1Q446.59999999999997 -8.8 434.69999999999993 -3.0Q422.79999999999995 2.8000000000000003 407.79999999999995 2.8000000000000003ZM408.59999999999997 -21.0Q414.79999999999995 -21.0 419.0 -24.5Q423.2 -28.0 425.4 -34.8Q427.59999999999997 -41.6 427.59999999999997 -51.0Q427.59999999999997 -61.400000000000006 425.19999999999993 -68.5Q422.79999999999995 -75.60000000000001 418.29999999999995 -79.4Q413.79999999999995 -83.2 407.4 -83.2Q401.4 -83.2 397.2 -79.7Q393.0 -76.2 390.79999999999995 -69.4Q388.59999999999997 -62.6 388.59999999999997 -53.0Q388.59999999999997 -37.800000000000004 393.9 -29.400000000000002Q399.2 -21.0 408.59999999999997 -21.0Z';
const MURO_BOX = [7.2, -108.4, 453.2, 111.2]; // x, y, largeur, hauteur du wordmark
const MARCEL_HEAD = `<g stroke="#111111" stroke-width="7" stroke-linejoin="round" stroke-linecap="round">
<path d="M70,124 C48,114 38,146 54,156 C62,161 70,158 72,152" fill="#F7E8D3"/>
<path d="M56,134 C52,140 55,147 61,148" fill="none" stroke-width="5"/>
<path d="M64,124 C62,84 90,62 124,62 C162,62 186,88 186,126 C186,170 158,198 122,198 C86,198 66,166 64,124 Z" fill="#F7E8D3"/>
<path d="M54,98 C48,70 84,44 128,44 C172,44 204,62 200,84 C197,100 172,100 152,94 C128,87 98,92 78,104 C66,111 56,108 54,98 Z" fill="#111111"/>
<path d="M126,44 C122,34 128,26 137,29" fill="none"/>
<path d="M96,106 Q106,99 116,105 M138,104 Q148,98 158,105" fill="none" stroke-width="6"/>
<path d="M128,128 C142,126 146,146 130,148" fill="#F7E8D3" stroke-width="6"/>
<path d="M126,150 C114,142 96,144 88,154 C84,160 77,160 74,153 C75,168 94,174 108,168 C117,164 123,160 126,157 C129,160 135,164 144,168 C158,174 177,168 178,153 C175,160 168,160 164,154 C156,144 138,142 126,150 Z" fill="#111111" stroke-width="3"/>
<path d="M104,170 C110,190 142,190 150,170 C134,177 120,177 104,170 Z" fill="#111111" stroke-width="4"/>
<path d="M117,180 C123,186 133,186 139,180 C132,178 124,178 117,180 Z" fill="#E8322B" stroke="none"/>
</g>
<g fill="#111111"><ellipse cx="107" cy="125" rx="8.5" ry="13"/><ellipse cx="150" cy="125" rx="8.5" ry="13"/></g>
<g fill="#F7E8D3"><path d="M107,125 L115,119 A8.5,13 0 0 0 110,112.5 Z"/><path d="M150,125 L158,119 A8.5,13 0 0 0 153,112.5 Z"/></g>`; // repère 240×240, visage centré vers (124,130)

const C = { ink: '#111111', creme: '#F6F1E7', rouge: '#E8322B', bleu: '#1A3DE0', citron: '#CBEF6E', peau: '#F7E8D3', vert: '#1E4636' };

function marcel({ x, y, size, line = C.ink, face = C.peau, beret = C.ink, tongue = C.rouge, rot = 0 }) {
  const k = size / 160; // largeur utile de la tête ≈ 160 unités
  let g = MARCEL_HEAD;
  if (line !== C.ink || face !== C.peau || beret !== C.ink || tongue !== C.rouge) {
    g = g.replaceAll('#111111', '§L').replaceAll('#F7E8D3', '§F').replaceAll('#E8322B', '§T')
      .replaceAll('§L', line).replaceAll('§F', face).replaceAll('§T', tongue);
    if (beret !== line) g = g.replace(`fill="${line}"/>\n<path d="M126,44`, `fill="${beret}"/>\n<path d="M126,44`);
  }
  return `<g transform="translate(${x} ${y}) rotate(${rot}) scale(${k.toFixed(4)}) translate(-124 -122)">${g}</g>`;
}

function wordmark(fill, dot, cx, cy, width) {
  const [x0, y0, w, h] = MURO_BOX;
  const s = width / w;
  return `<path d="${MURO_WORD}" fill="${fill}" transform="translate(${(cx - width / 2).toFixed(2)} ${(cy - (h * s) / 2).toFixed(2)}) scale(${s.toFixed(4)}) translate(${-x0} ${-y0})"/>
    ${dot ? `<circle cx="${(cx + width / 2 + h * s * 0.16).toFixed(2)}" cy="${(cy + (h * s) / 2 - h * s * 0.11).toFixed(2)}" r="${(h * s * 0.11).toFixed(2)}" fill="${dot}"/>` : ''}`;
}

/* Collection « Six quartiers » : une seule raquette carbone (même forme), six décors. */
const RACKET_SHAPE = 'M110,312 C92,290 14,236 12,140 C10,58 64,8 130,8 C196,8 250,58 248,140 C246,236 168,290 150,312 Z';
const RACKET_THROAT = 'M110,256 H150 Q156,256 153,261 L134,293 Q130,299 126,293 L107,261 Q104,256 110,256 Z';
const NAVY = '#1C2E86';
const CREAM_FRAME = '#F2EDE3';

const RACKET_LOOKS = {
  monceau:        { holeX: [70, 190], face: C.citron, frame: C.bleu, throat: C.bleu, frameText: C.creme, collar: C.bleu, ring: C.rouge, grip: '#F3EFE6', word: C.ink, dot: C.rouge, hole: '#2B2A1E', pattern: 'grille' },
  marais:         { face: C.creme, frame: C.rouge, throat: C.ink, frameText: C.creme, collar: C.citron, ring: C.citron, grip: '#F3EFE6', word: C.ink, dot: C.rouge, hole: '#2B2622', pattern: 'store' },
  bastille:       { face: C.rouge, frame: C.rouge, throat: C.ink, frameText: C.creme, collar: C.ink, ring: C.citron, grip: '#F3EFE6', word: C.creme, dot: C.citron, hole: '#3A1411', pattern: 'court' },
  etoile:         { face: '#151517', frame: '#111111', throat: C.ink, frameText: C.creme, collar: C.ink, ring: C.rouge, grip: '#1B1B1D', word: C.creme, dot: C.rouge, hole: '#3B3A37', pattern: 'etoile', stripe: C.citron, serial: '017/300' },
  'saint-germain': { face: C.creme, frame: CREAM_FRAME, throat: C.ink, frameText: NAVY, collar: NAVY, ring: C.rouge, grip: '#F3EFE6', word: C.ink, dot: C.rouge, hole: '#2B2622', pattern: 'mariniere', outline: true },
  opera:          { face: C.creme, frame: C.rouge, throat: C.ink, frameText: C.creme, collar: C.citron, ring: C.citron, grip: '#F3EFE6', word: C.ink, dot: C.rouge, hole: '#2B2622', pattern: 'opera' }
};

let racketUid = 0;

// petit générateur pseudo-aléatoire stable (mêmes points citron à chaque rendu)
function seeded(n) { let s = n; return () => (s = (s * 9301 + 49297) % 233280) / 233280; }

function racketPattern(p, L, u) {
  switch (L.pattern) {
    case 'grille': { // grille ouvragée du parc Monceau + feuillage
      let leaves = '';
      const leaf = (x, y, r) => `<ellipse cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" rx="3.6" ry="7.5" transform="rotate(${r.toFixed(0)} ${x.toFixed(1)} ${y.toFixed(1)})"/>`;
      for (let y = 212; y > 96; y -= 17) { leaves += leaf(42, y, -35) + leaf(218, y, 35) + leaf(36, y - 6, 30) + leaf(224, y - 6, -30); }
      for (let i = 0; i <= 10; i++) {
        const t = i / 10, a = Math.PI * (1 - t);
        const x = 130 + 86 * Math.cos(a), y = 92 - 62 * Math.sin(a);
        leaves += leaf(x + 7 * Math.cos(a), y - 9 * Math.sin(a), (t - 0.5) * 160);
      }
      return `<g fill="none" stroke="${NAVY}" stroke-width="3">
          <path d="M52,222 V92 C52,52 88,34 130,34 C172,34 208,52 208,92 V222"/>
          <path d="M60,222 V94 C60,60 92,44 130,44 C168,44 200,60 200,94 V222" stroke-width="1.6"/>
          <circle cx="130" cy="30" r="10" fill="${C.citron}"/><circle cx="130" cy="30" r="5"/>
          <path d="M120,30 H104 M140,30 H156" stroke-width="2"/>
        </g>
        <g fill="${NAVY}">${leaves}</g>`;
    }
    case 'store': { // store de terrasse rayé, bord festonné
      const scallops = Array.from({ length: 10 }, () => 'q13,15 26,0').join(' ');
      return `<clipPath id="${u}st"><path d="M0,0 H260 V112 H260 L0,112 Z M0,112 ${scallops} V112 Z"/></clipPath>
        <g clip-path="url(#${u}st)">
          <rect width="260" height="140" fill="${C.creme}"/>
          ${Array.from({ length: 10 }, (_, i) => `<rect x="${i * 26 + 4}" width="13" height="140" fill="${C.rouge}"/>`).join('')}
        </g>
        <path d="M0,112 ${scallops}" fill="none" stroke="${C.ink}" stroke-width="2.6"/>`;
    }
    case 'court': // terrain de padel à la craie
      return `<g fill="none" stroke="${C.creme}" stroke-width="3">
          <rect x="44" y="32" width="172" height="166"/>
          <path d="M44,74 H216 M130,74 V114 M120,114 H140"/>
        </g>
        <rect x="94" y="186" width="72" height="18" fill="${C.rouge}"/>`;
    case 'etoile': { // place de l'Étoile : rayons blancs + éclats citron
      const cx = 130, cy = 150;
      let rays = '';
      for (let i = 0; i < 20; i++) {
        const a = (i * 18 + 9) * Math.PI / 180;
        rays += `M${(cx + 34 * Math.cos(a)).toFixed(1)},${(cy + 34 * Math.sin(a)).toFixed(1)}L${(cx + 240 * Math.cos(a)).toFixed(1)},${(cy + 240 * Math.sin(a)).toFixed(1)}`;
      }
      const rnd = seeded(7);
      const dots = Array.from({ length: 34 }, () => `<circle cx="${(30 + rnd() * 200).toFixed(1)}" cy="${(24 + rnd() * 200).toFixed(1)}" r="${(1.4 + rnd() * 1.6).toFixed(1)}"/>`).join('');
      return `<path d="${rays}" stroke="#FFFFFF" stroke-width="1.7" opacity=".9"/>
        <g fill="${C.citron}">${dots}</g>`;
    }
    case 'mariniere': // marinière bleu + bande rouge
      return `<rect width="260" height="44" fill="${NAVY}"/>
        ${[58, 86, 114, 142, 170].map(y => `<rect y="${y}" width="260" height="14" fill="${NAVY}"/>`).join('')}
        <rect x="176" y="0" width="20" height="150" fill="${C.rouge}"/>`;
    case 'opera': { // cadre Art déco + 09
      const deco = 'M58,30 H202 V42 H212 V208 H202 V220 H58 V208 H48 V42 H58 Z';
      return `<path d="${deco}" fill="none" stroke="${C.rouge}" stroke-width="3"/>
        <path d="${deco}" transform="translate(130 125) scale(.93) translate(-130 -125)" fill="none" stroke="${C.rouge}" stroke-width="1.2"/>
        <text x="130" y="126" text-anchor="middle" font-family="Bricolage Grotesque, Helvetica Neue, Arial, sans-serif" font-weight="800" font-size="104" letter-spacing="-5" fill="${NAVY}">09</text>
        <g font-family="DM Mono, Menlo, monospace" font-size="7.5" letter-spacing="1.2" fill="${C.ink}">
          <text x="62" y="178">PARIS</text><text x="198" y="178" text-anchor="end">SAISON 01</text>
        </g>`;
    }
    default:
      return '';
  }
}

/* Plaque de rue : émail bleu, filet crème, cadre sombre. */
function plaque(p, y = 222) {
  const w = Math.max(80, p.name.length * 6.6 + 18);
  return `<g font-family="Bricolage Grotesque, Helvetica Neue, Arial, sans-serif" text-anchor="middle">
    <rect x="${130 - w / 2}" y="${y}" width="${w}" height="22" rx="4" fill="${NAVY}" stroke="${C.ink}" stroke-width="2"/>
    <rect x="${133 - w / 2}" y="${y + 3}" width="${w - 6}" height="16" rx="2.5" fill="none" stroke="${C.creme}" stroke-width=".9"/>
    <text x="130" y="${y + 14.6}" font-size="8.4" font-weight="700" fill="${C.creme}" letter-spacing=".5">${p.name}</text>
  </g>`;
}

function racketHandle(L, u, x = 111, w = 38) {
  const cx = x + w / 2;
  return `
    <pattern id="${u}g" width="8" height="8" patternUnits="userSpaceOnUse"><rect width="8" height="8" fill="${L.grip}"/><circle cx="2" cy="2" r=".9" fill="#000" fill-opacity=".14"/><circle cx="6" cy="6" r=".9" fill="#000" fill-opacity=".14"/></pattern>
    <rect x="${x}" y="310" width="${w}" height="13" rx="3" fill="${L.collar}"/>
    <rect x="${x + 2}" y="321" width="${w - 4}" height="118" rx="7" fill="url(#${u}g)" stroke="#000" stroke-opacity=".18" stroke-width="1.2"/>
    <path d="M${x + 2},350 H${x + w - 2} M${x + 2},380 H${x + w - 2} M${x + 2},410 H${x + w - 2}" stroke="#000" stroke-opacity=".08" stroke-width="2"/>
    <rect x="${cx - 18}" y="434" width="36" height="14" rx="6" fill="${L.grip}" stroke="#000" stroke-opacity=".12"/>
    <path d="M${cx + 14},446 C${cx + 60},452 ${cx + 92},452 ${cx + 92},462 C${cx + 92},474 ${cx + 46},470 ${cx + 12},450" fill="none" stroke="${C.ink}" stroke-width="5" stroke-linecap="round"/>
    <circle cx="${cx + 13}" cy="446" r="5" fill="none" stroke="${L.ring}" stroke-width="2.6"/>`;
}

function racketProfile(p, L, u) {
  const [x0, y0, w, h] = MURO_BOX;
  const s = 80 / w;
  return `<svg viewBox="0 0 260 480" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="${p.name}, vue de profil">
    <rect x="113" y="8" width="34" height="304" rx="17" fill="${L.frame}" ${L.outline ? `stroke="${C.ink}" stroke-width="1.5"` : ''}/>
    <g transform="translate(${130 - (h * s) / 2} 200) rotate(-90)"><path d="${MURO_WORD}" transform="scale(${s.toFixed(4)}) translate(${-x0} ${-y0})" fill="${L.frameText}"/></g>
    ${racketHandle(L, u, 112, 36)}
    <g stroke="currentColor" stroke-width="1.2" opacity=".6" fill="none">
      <path d="M86,8V448 M80,8H92 M80,448H92"/>
      <path d="M96,160H111 M149,160H164"/>
      <path d="M106,156L111,160L106,164 M154,156L149,160L154,164"/>
    </g>
    <g font-family="DM Mono, monospace" font-size="10" fill="currentColor" opacity=".8">
      <text x="76" y="228" transform="rotate(-90 76 228)" text-anchor="middle">455 mm</text>
      <text x="170" y="164">38 mm</text>
    </g>
  </svg>`;
}

function racketSVG(id, { view = 'front' } = {}) {
  const p = findProduct(id);
  const L = RACKET_LOOKS[id];
  const u = 'mr' + (++racketUid);
  if (view === 'profile') return racketProfile(p, L, u);

  const isBack = view === 'back';
  const vb = view === 'detail' ? '40 116 180 180' : '0 0 260 480';
  const T = (k, cx, cy) => `transform="translate(${cx} ${cy}) scale(${k}) translate(${-cx} ${-cy})"`;

  // perçage : grille droite sur le haut de la face, zone de Marcel / logo / plaque laissée libre
  let holes = '';
  const [hx0, hx1] = L.holeX || [34, 226];
  for (let y = 40; y <= 206; y += 19) {
    for (let x = 35; x <= 225; x += 19) {
      if (x < hx0 || x > hx1) continue;
      if (isBack ? (y > 104 && y < 200) : (y > 128 && x > 74 && x < 186)) continue;
      holes += `<circle cx="${x}" cy="${y}" r="3.9"/>`;
    }
  }

  const front = `${marcel({ x: 130, y: 160, size: 46 })}
    ${wordmark(L.word, L.dot, 128, 196, 72)}
    ${plaque(p, 212)}
    ${L.serial ? `<text x="130" y="246" text-anchor="middle" font-family="DM Mono, Menlo, monospace" font-size="7" letter-spacing="1" fill="${C.creme}">${L.serial}</text>` : ''}`;
  const back = `${wordmark(L.word, L.dot, 128, 150, 150)}
    <text x="130" y="186" text-anchor="middle" font-family="DM Mono, Menlo, monospace" font-size="7" letter-spacing="1.6" fill="${L.word}">PARIS · PADEL · ${p.name}</text>`;

  const [x0, y0, w, h] = MURO_BOX;
  const fs = 34 / w;

  return `<svg viewBox="${vb}" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Raquette ${p.name}">
    <defs>
      <clipPath id="${u}hc"><path d="${RACKET_SHAPE}" ${T(0.84, 130, 140)}/></clipPath>
      <clipPath id="${u}fc"><path d="${RACKET_SHAPE}" ${T(0.92, 130, 140)}/></clipPath>
      <clipPath id="${u}fb"><path d="M0,0H260V246Q130,282 0,246Z"/></clipPath>
      <clipPath id="${u}hd"><path d="${RACKET_SHAPE}"/></clipPath>
      <mask id="${u}m" maskUnits="userSpaceOnUse" x="0" y="0" width="260" height="480">
        <rect width="260" height="480" fill="#fff"/>
        <path d="${RACKET_THROAT}" fill="#000"/>
      </mask>
    </defs>
    <g mask="url(#${u}m)">
      <path d="${RACKET_SHAPE}" fill="${L.frame}"/>
      <g clip-path="url(#${u}hd)"><rect y="246" width="260" height="70" fill="${L.throat}"/></g>
      <g clip-path="url(#${u}fc)"><g clip-path="url(#${u}fb)">
        <rect width="260" height="480" fill="${L.face}"/>
        ${racketPattern(p, L, u)}
        <g clip-path="url(#${u}hc)" fill="${L.hole}" stroke="#000" stroke-opacity=".35" stroke-width=".8">${holes}</g>
        ${isBack ? back : front}
      </g></g>
      ${L.stripe ? `<path d="${RACKET_SHAPE}" fill="none" stroke="${L.stripe}" stroke-width="1.6" ${T(0.958, 130, 140)}/>` : ''}
      ${L.outline ? `<path d="${RACKET_SHAPE}" fill="none" stroke="${C.ink}" stroke-opacity=".5" stroke-width="1.4"/>` : ''}
      <g transform="translate(${(16.5 - (h * fs) / 2).toFixed(2)} 168) rotate(-90)"><path d="${MURO_WORD}" transform="scale(${fs.toFixed(4)}) translate(${-x0} ${-y0})" fill="${L.frameText}"/></g>
    </g>
    ${racketHandle(L, u)}
  </svg>`;
}

function accSVG(id) {
  const u = 'ma' + (++racketUid);
  const SW = `stroke="${C.ink}" stroke-width="5" stroke-linejoin="round"`;
  if (id === 'surgrips') {
    const roll = (x, c) => `<rect x="${x}" y="40" width="40" height="122" rx="18" fill="${c}" ${SW}/>
      <rect x="${x}" y="40" width="40" height="122" rx="18" fill="url(#${u})"/>
      <rect x="${x}" y="90" width="40" height="20" fill="${C.ink}"/>`;
    return `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Surgrips MURO">
      <defs><pattern id="${u}" width="40" height="10" patternUnits="userSpaceOnUse"><path d="M0,10L40,0" stroke="#000" stroke-opacity=".12" stroke-width="2.4"/></pattern></defs>
      ${roll(32, C.creme)}${roll(80, C.citron)}${roll(128, C.rouge)}
      ${[52, 100, 148].map(x => wordmark(C.creme, null, x, 100, 30)).join('')}</svg>`;
  }
  if (id === 'protege') {
    const arc = 'M30,172 C26,88 62,32 100,32 C138,32 174,88 170,172';
    return `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Protège-cadre MURO">
      <path d="${arc}" fill="none" stroke="${C.ink}" stroke-width="18" stroke-linecap="round"/>
      <path d="${arc}" fill="none" stroke="#fff" stroke-opacity=".65" stroke-width="28" pathLength="100" stroke-dasharray="0 22 56 22" stroke-linecap="round"/>
      <g stroke="${C.ink}" stroke-width="4" stroke-linecap="round"><path d="M100,8V18 M132,14L128,24 M68,14L72,24"/></g></svg>`;
  }
  return `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Sac Terrasse MURO">
    <defs><pattern id="${u}" width="20" height="10" patternUnits="userSpaceOnUse"><rect width="10" height="10" fill="${C.creme}"/><rect x="10" width="10" height="10" fill="${C.rouge}"/></pattern></defs>
    <path d="M70,74 C70,44 130,44 130,74" fill="none" stroke="${C.ink}" stroke-width="9" stroke-linecap="round"/>
    <rect x="22" y="70" width="156" height="98" rx="22" fill="url(#${u})" ${SW}/>
    <path d="M24,112 ${Array.from({ length: 8 }, () => 'q9.5,11 19,0').join(' ')} V146 H24 Z" fill="${C.creme}" ${SW}/>
    <path d="M22,140 H178 V146 C178,158 168,168 156,168 H44 C32,168 22,158 22,146 Z" fill="${C.ink}"/>
    ${marcel({ x: 100, y: 128, size: 30 })}
    ${wordmark(C.creme, C.citron, 96, 156, 40)}</svg>`;
}

function productVisual(p, opts) {
  return p.type === 'racket' ? racketSVG(p.id, opts) : accSVG(p.id);
}
